import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
// import axios from "axios";
import axios from "../../../context/axios";
import { initTE, Ripple } from "tw-elements";

const SpecialExplorer = () => {
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]); // unused for now
  const [showAll, setShowAll] = useState(false);
  const location = useLocation();

  // Ref for the scroll container
  const packageContainerRef = useRef(null);
  const [specialTours, setSpecialTours] = useState([]);

  useEffect(() => {
    const fetchSpecialOffers = async () => {
      try {
        const response = await axios.get("/package/special-offer");
        setSpecialTours(response.data);
      } catch (err) {
        console.error("Failed to fetch special offer tours", err);
      }
    };

    fetchSpecialOffers();
  }, []);
  // Static packages for cards (not based on category yet)
 

  useEffect(() => {
    initTE({ Ripple });

    const fetchData = async () => {
      try {
        const [catRes, stateRes] = await Promise.all([
          axios.get("/categories"),
          axios.get("/states"),
        ]);

        setCategories(catRes.data);
        setStates(stateRes.data);
      } catch (error) {
        console.error("Failed to fetch categories or states:", error);
      }
    };

    fetchData();
  }, []);

  const activePath =
    location.pathname || (categories.length > 0 ? categories[0].path : "");

  // Scroll helpers
  const scrollLeft = () => {
    if (packageContainerRef.current) {
      packageContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (packageContainerRef.current) {
      packageContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };


  return (
    <>
      {/* Packages Section */}
      <section className="w-full mt-6 relative">
        {/* Scroll Buttons */}
        <button
          onClick={scrollLeft}
          aria-label="Scroll packages left"
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
          style={{ boxShadow: "0 0 6px rgba(0,0,0,0.15)" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={scrollRight}
          aria-label="Scroll packages right"
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
          style={{ boxShadow: "0 0 6px rgba(0,0,0,0.15)" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* Packages Container */}
        <div
  ref={packageContainerRef}
  className="flex space-x-6 overflow-x-auto no-scrollbar px-6 py-4"
  style={{ scrollBehavior: "smooth" }}
>
  {specialTours.map((pkg) => (
    // <div
    //   key={pkg._id}
      <Link
      to={`/tours/${pkg._id}`}
      key={pkg._id}
      className="min-w-[250px] max-w-[250px] rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 cursor-pointer flex-shrink-0"
    >
      <img
        src={pkg.img}
        alt={pkg.title}
        className="w-full h-40 object-cover rounded-t-lg"
      />
      <div className="p-4">
        <h3 className="text-lg font-semibold mb-1">{pkg.title}</h3>
        <p className="text-gray-600 text-sm">
          {pkg.duration.day} Days &nbsp;|&nbsp; {pkg.duration.night} Nights
        </p>
        {/* <p className="text-sm text-blue-500 mt-1">{pkg.region}</p> */}
      </div>
    </Link>
  ))}

  {/* "+ More" Card */}
  {/* <div className="min-w-[250px] max-w-[250px] rounded-lg shadow-md bg-gray-100 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors duration-300 flex-shrink-0">
    <div className="text-5xl font-bold text-gray-600 select-none">+</div>
    <p className="mt-2 text-lg font-semibold text-gray-700 select-none">
      More
    </p>
  </div> */}
</div>
      </section>

      {/* Global styles to hide scrollbar but allow scroll */}
      <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </>
  );
};

export default SpecialExplorer;
